module.exports = __webpack_public_path__ + "static/img/banner3.65c735c2.png";